import { useEffect, useState } from "react";
import {
    Card,
    Col,
    Row,
    Typography,
    Tooltip,
    Select,
    DatePicker,
    Form,
    theme,
    Button
} from "antd";
import {
    RiseOutlined,
    FallOutlined,
    SearchOutlined,
} from "@ant-design/icons";
import Echart from "../../components/chart/EChart";
import { Images } from "../../assets";
import dayjs from "dayjs";
import LoadingBase from "../../components/LoadingBase";
import { getListAccount, getListShops, getOrdersChart, getShopPerformance } from "../../services/apis";
import { consoleLogUtil } from "../../utils/consoleLogUtil";
import { filterOption, filterShopsByUser, formatNumber, isAdmin } from "../../utils/funcHelper";
import { useSelector } from "react-redux";
import { RATE_EURO_TO_USD, requiredItem } from "../../constants/constants";

const { Title } = Typography;

const { RangePicker } = DatePicker;

const DATA_DEFAULT = {
    top: [
        {
            key: "gmv",
            today: 0,
            title: "REVENUE",
            persent: 0,
            icon: Images.ic_shift,
            bnb: "bnb2",
            classBox: "icon-box",
            toolTip: "Tổng doanh thu hàng hóa bán ra (Gross Merchandise Value)."
        },
        {
            key: "orders",
            today: 0,
            title: "PROFIT/ĐƠN HÀNG",
            persent: 0,
            icon: Images.ic_order,
            bnb: "bnb2",
            classBox: "icon-box",
            toolTip: "Lợi nhuận trên số đơn hàng trong khoảng thời gian."
        },
        {
            key: "buyers",
            today: 0,
            title: "BASE COST",
            persent: 0,
            icon: Images.ic_customer,
            bnb: "bnb2",
            classBox: "icon-box",
            toolTip: "Tổng chi phí sản xuất hàng hóa (Total Cost)."
        },
        {
            key: "aov",
            today: 0,
            title: "EST . EARNINGS",
            persent: 0,
            icon: Images.ic_average,
            bnb: "redtext",
            classBox: "icon-box",
            toolTip: "Tổng lợi nhuận ước tính (Estimated Earnings)."
        },
    ],
    right: [
        {
            key: "waiting",
            today: 0,
            prev: 0,
            title: "WAITING",
            persent: 0,
            icon: Images.ic_waiting,
            bnb: "bnb2",
            classBox: "icon-box",
            toolTip: "Số đơn hàng chờ xử lý"
        },
        {
            key: "processing",
            today: 0,
            prev: 0,
            title: "PROCESSING",
            persent: 0,
            icon: Images.ic_process,
            bnb: "bnb2",
            classBox: "icon-box",
            toolTip: "Số đơn hàng đang xử lý"
        },
        {
            key: "completed",
            today: 0,
            prev: 0,
            title: "COMPLETED",
            persent: 0,
            icon: Images.ic_completed,
            bnb: "bnb2",
            classBox: "icon-box",
            toolTip: "Số đơn hàng đã hoàn thành"
        },
        {
            key: "cancelled",
            today: 0,
            prev: 0,
            title: "CANCELLED",
            persent: 0,
            icon: Images.ic_canceled,
            bnb: "redtext",
            classBox: "icon-box",
            toolTip: "Số đơn hàng đã hủy"
        }
    ]
};


const DashboardPage = () => {
    const [dataChart, setDataChart] = useState([]);
    const [dataTop, setDataTop] = useState(DATA_DEFAULT.top);
    const [dataRight, setDataRight] = useState(DATA_DEFAULT.right);
    const [loading, setLoading] = useState(false);
    const [dataShops, setDataShops] = useState([]);
    const [dataSellers, setDataSellers] = useState([]);
    const { token } = theme.useToken();
    const [form] = Form.useForm();
    const userReducer = useSelector((state) => state?.userReducer?.data);
    consoleLogUtil("userReducer dashboard", userReducer);
    const initialValues = {
        date: [dayjs().subtract(7, 'day').startOf('day'), dayjs().endOf('day')]
    };
    const formStyle = {
        maxWidth: 'none',
        background: 'white',
        borderRadius: token.borderRadiusLG,
        paddingLeft: 0,
        paddingRight: 0,
        marginBottom: 0,
    };
    const mapPerformanceToData = (apiData) => {
        if (!apiData) return { top: [], right: [] };

        return {
            top: [
                {
                    key: "gmv",
                    today: apiData?.total_revenue ?? 0,
                    title: "REVENUE",
                    persent: 0,
                    icon: Images.ic_shift,
                    bnb: "bnb2",
                    classBox: "icon-box",
                    toolTip: "Tổng doanh thu hàng hóa bán ra"
                },
                {
                    key: "orders",
                    today: `${formatNumber(parseFloat(apiData?.total_est_earned) * RATE_EURO_TO_USD - parseFloat(apiData?.total_cost ?? 0),2)}/${apiData?.total_orders ?? 0}` ,
                    title: "PROFIT/ORDERS",
                    persent: 0,
                    icon: Images.ic_order,
                    bnb: "bnb2",
                    classBox: "icon-box",
                    toolTip: "Lợi nhuận trên số lượng đơn hàng"
                },
                {
                    key: "buyers",
                    today: apiData?.total_cost ? formatNumber(parseFloat(apiData?.total_cost), 2) : 0,
                    title: "BASE COST",
                    persent: 0,
                    icon: Images.ic_customer,
                    bnb: "bnb2",
                    classBox: "icon-box",
                    toolTip: "Chi phí sản xuất"
                },
                {
                    key: "aov",
                    today: apiData?.total_est_earned ? formatNumber(parseFloat(apiData?.total_est_earned) * RATE_EURO_TO_USD, 2) : 0,
                    title: "EST . EARNINGS",
                    persent: 0,
                    icon: Images.ic_average,
                    bnb: "bnb2",
                    classBox: "icon-box",
                    toolTip: "Tổng lợi nhuận ước tính"
                }
            ],
            right: [
                {
                    key: "waiting",
                    today: apiData?.waiting_orders ?? 0,
                    prev: 0,
                    title: "WAITING",
                    persent: 0,
                    icon: Images.ic_waiting,
                    bnb: "bnb2",
                    classBox: "icon-box",
                    toolTip: "Số đơn hàng chờ xử lý"
                },
                {
                    key: "processing",
                    today: apiData?.processing_orders ?? 0,
                    prev: 0,
                    title: "PROCESSING",
                    persent: 0,
                    icon: Images.ic_process,
                    bnb: "bnb2",
                    classBox: "icon-box",
                    toolTip: "Số đơn hàng đang xử lý"
                },
                {
                    key: "completed",
                    today: apiData?.completed_orders ?? 0,
                    prev: 0,
                    title: "COMPLETED",
                    persent: 0,
                    icon: Images.ic_completed,
                    bnb: "bnb2",
                    classBox: "icon-box",
                    toolTip: "Số đơn hàng đã hoàn thành"
                },
                {
                    key: "cancelled",
                    today: apiData?.cancelled_orders ?? 0,
                    prev: 0,
                    title: "CANCELLED",
                    persent: 0,
                    icon: Images.ic_canceled,
                    bnb: "redtext",
                    classBox: "icon-box",
                    toolTip: "Số đơn hàng đã hủy"
                }
            ]
        };
    };

    const getDataChart = async (shop_ids, from_date, to_date) => {
        const params = {
            shop_ids: shop_ids,
            from_date: from_date,
            to_date: to_date
        }
        const res = await getOrdersChart(params);
        consoleLogUtil("res chart", res);
        if (res && res?.status === 1) {
            setDataChart(res?.data || []);
        } else {
            setDataChart([]);
        }
    }

    const getDataDashboard = async (shop_ids, start_date, end_date) => {
        const params = {
            shop_ids: shop_ids,
            start_date: start_date,
            end_date: end_date
        }
        const res = await getShopPerformance(params);
        if (res && res.status === 1) {
            const mappedData = mapPerformanceToData(res?.data);
            consoleLogUtil("mappedData", mappedData);
            setDataTop(mappedData.top);
            setDataRight(mappedData.right);
        } else {
            setDataTop(DATA_DEFAULT.top);
            setDataRight(DATA_DEFAULT.right);
        }
    }
    const callAPIDashboard = (shop_ids, from_date, to_date) => {
        setLoading(true);
        Promise.all([getDataChart(shop_ids, from_date, to_date), getDataDashboard(shop_ids, from_date, to_date)])
            .finally(() => setLoading(false));
    }
    const getUnitByIndex = (index) => {
        switch (index) {
            case 0:
                return "GBP"; // Đơn vị cho index = 0
            case 3:
                return "USD"; // Đơn vị cho index = 3    
            case 1:
                return "Order"; // Đơn vị cho index = 1
            case 2:
                return "USD"; // Đơn vị cho index = 2
            default:
                return ""; // Không có đơn vị cho các trường hợp khác
        }
    };
    const getUnitRow2ByIndex = (index) => {
        switch (index) {
            case 0:
            case 1:
            case 2:
            case 3:
                return "Order"; // Đơn vị cho index = 0 và index = 1
            default:
                return ""; // Không có đơn vị cho các trường hợp khác
        }
    };

    const getDataShops = async () => {
        try {
            const params = {
                name: '',
            }
            const res = await getListShops(params);
            if (res && res.status === 1) {
                const lstShop = res?.data?.data;

                // Lọc các shop mà user được phân quyền
                const filteredShops = filterShopsByUser(lstShop, userReducer);

                setDataShops(filteredShops?.map((item, index) => ({
                    ...item,
                    value: item?.shop_id,
                    label: `${index + 1}. ${item?.shop_name}`,
                })));
            } else {
                setDataShops([]);
            }
        } catch (error) {
            setLoading(false);
            console.log('error', error);
        }
    }

    const getDataSellers = async () => {
        try {
            const params = {
                keyword: '',
                department_id: null,
                limit: 100,
                currentPage: 1,
            }
            const res = await getListAccount(params);
            if (res && res.status === 1) {
                setDataSellers([...res?.data?.data?.filter(item => item.departments?.some(de => de.id === '5')).map((item, index) => ({
                        ...item,
                        value: item?.id,
                        label: `${index + 1}. ${item?.fullname}`,
                    }))
                ]);
            } else {
                setDataSellers([]);
            }
        } catch (error) {
            setLoading(false);
            console.log('error', error);
        }
    }
    const handleChangeSeller = (value, option) => {
        // Reset selected shops when seller changes
        const shopIds = option?.shops?.map(shop => {
            const shopInList = dataShops.find(s => s.id === shop.id);
            return shopInList ? shopInList.shop_id : null;
        }) || [];
        form.setFieldValue('shop_ids', shopIds);
    }
    const onFinish = async (dataForm) => {
        const shop_ids = dataForm?.shop_ids;
        const from_date = dataForm?.date ? dataForm.date[0].format('YYYY-MM-DD') + " 00:00:00" : null;
        const to_date = dataForm?.date ? dataForm.date[1].format('YYYY-MM-DD') + " 23:59:59" : null;
        callAPIDashboard(shop_ids, from_date, to_date);
    };
    useEffect(() => {
        setLoading(true);
        Promise.all([getDataSellers(), getDataShops()]).finally(() => {
            setLoading(false);
        });
       
    }, []);

    return (
        <div className="layout-content">
            <Form form={form} name="advanced_search" style={formStyle} onFinish={onFinish} initialValues={initialValues}>
                <Row gutter={24}>
                    <Col span={6}>
                        <Form.Item
                            name="seller_id"
                        >
                            <Select
                                showSearch
                                placeholder={'Chọn seller'}
                                style={{ width: '100%', height: 40 }}
                                defaultActiveFirstOption={false}
                                filterOption={filterOption}
                                notFoundContent={null}
                                options={dataSellers}
                                onChange={(value, option) => handleChangeSeller(value, option)}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={6}>
                        <Form.Item
                            name="shop_ids"
                            rules={requiredItem}
                        >
                            <Select
                                showSearch
                                placeholder={'Chọn shop'}
                                style={{ width: '100%', height: 40 }}
                                defaultActiveFirstOption={false}
                                filterOption={filterOption}
                                notFoundContent={null}
                                options={dataShops}
                                mode="multiple"
                                maxTagCount={'responsive'}
                                onChange={(value, option) => {
                                    form.setFieldValue('seller_id', null);
                                }}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item
                            name="date"
                        >
                            <RangePicker
                                allowClear={false}
                                style={{ width: '100%', height: 40 }}
                            />
                        </Form.Item>
                    </Col>

                    <Col span={3}>
                        <Tooltip title="Xem số liệu">
                            <Button type="primary" htmlType="submit">
                                <SearchOutlined />
                            </Button>
                        </Tooltip>
                    </Col>
                </Row>
            </Form>
            {/* Top cards */}
            <Row className="rowgap-vbox" gutter={[24, 0]}>
                {dataTop?.map((c, index) => (
                    <Col key={index} xs={24} sm={24} md={12} lg={6} xl={6} className="mb-24">
                        <Card bordered={false} className="criclebox ">
                            <div className="number">
                                <Row align="middle" gutter={[24, 0]}>
                                    <Col xs={18}>
                                        <span>{c.title}</span>
                                        <Tooltip placement="top" title={c.toolTip}>
                                            <Title level={3}>
                                                {c.today} {<small className="txt-unit">{getUnitByIndex(index)}</small>}
                                            </Title>
                                        </Tooltip>
                                    </Col>
                                    <Col xs={6} style={{ display: "flex", alignItems: "center", flexDirection: "column" }}>
                                        {/* <Tooltip placement="top" title={"Tăng/giảm so với cùng kỳ trước"}>
                                            <div className="box-icon-chart">
                                                {c.persent > 0 ? <RiseOutlined style={{ color: "#52c41a" }} /> : (c.persent < 0 ? <FallOutlined style={{ color: "red" }} /> : null)}
                                                <small className={c.bnb}>{`${c.persent}%`}</small>
                                            </div>
                                        </Tooltip> */}
                                        <div className={c.classBox}><img src={c.icon} className="img-db" /></div>
                                    </Col>
                                </Row>
                            </div>
                        </Card>
                    </Col>
                ))}
            </Row>
            <Row gutter={[24, 0]}>
                {dataRight?.map((c, index) => (
                    <Col key={index} xs={24} sm={24} md={12} lg={6} xl={6} className="mb-24">
                        <Card bordered={false} className="criclebox ">
                            <div className="number">
                                <Row align="middle" gutter={[24, 0]}>
                                    <Col xs={18}>
                                        <span>{c.title}</span>
                                        <Tooltip placement="top" title={c.toolTip}>
                                            <Title level={3}>{c.today} <small>{getUnitRow2ByIndex(index)}</small></Title>
                                        </Tooltip>
                                    </Col>
                                    <Col xs={6} style={{ display: "flex", alignItems: "center", flexDirection: "column" }}>
                                        {/* <Tooltip placement="top" title="Tăng/giảm so với cùng kỳ trước">
                                            <div className="box-icon-chart">
                                                {c.persent > 0 ? <RiseOutlined style={{ color: "#52c41a" }} /> : (c.persent < 0 ? <FallOutlined style={{ color: "red" }} /> : null)}
                                                <small className={c.bnb}>{index === 2 ? `-` : `${c.persent}%`}</small>
                                            </div>
                                        </Tooltip> */}
                                        <div className={c.classBox}><img src={c.icon} className="img-db" /></div>
                                    </Col>
                                </Row>
                            </div>
                        </Card>
                    </Col>
                ))}
            </Row>
            {/* Chart + Complete List */}
            <Row gutter={[24, 0]}>
                <Col xs={24} sm={24} lg={24} xl={24} className="mb-24">
                    <Card bordered={false} className="criclebox h-full">
                        <Echart options={{
                            xaxis: { categories: dataChart?.map(item => dayjs(item.date).format("DD/MM")) }
                        }} series={[
                            { name: "Số order", data: dataChart?.map(item => item.total), color: "#fff" }
                        ]} />
                    </Card>
                </Col>
                <Col xs={24} sm={12} lg={12} xl={12} className="mb-24">

                </Col>
            </Row>
            <LoadingBase loading={loading} />
        </div>
    );
};

export default DashboardPage;
